<div class="modal-material" data-cy="modal-material">
  <div class="modal-header error">
    <p class="modal-title" data-cy="excel-upload-modal-title">{{invalidMaterials.length}} materials failed to
    upload</p>
    <button (click)="activeModal.dismiss()" class="close" type="button"></button>
  </div>

  <div class="modal-body">
    <div class="modal-text">
      <p>The following materials have failed validation for any number of reasons. You can download a copy,
      correct the invalid fields and submit again.</p>
      <p>Please see in the table below a summary of all errors.</p>
    </div>

    <app-excel-download [invalidMaterials]="invalidMaterials"></app-excel-download>

    <table class="list-table">
      <thead>
        <tr class="list-row" data-cy="excel-upload-table-header-row">
          <th class="list-header-element">
            <span data-cy="excel-upload-table-header-row-number">Row</span>
          </th>
          <th class="list-header-element dynamic">
            <span data-cy="excel-upload-table-header-material">Material</span>
          </th>
          <th class="list-header-element">
            <span data-cy="excel-upload-table-header-ordered-quantity">Ordered Quantity</span>
          </th>
          <th class="list-header-element">
            <span data-cy="excel-upload-table-header-model-type">Model type</span>
          </th>
          <th class="list-header-element">
            <span data-cy="excel-upload-table-header-lot-number">LOT No</span>
          </th>
          <th class="list-header-element">
            <span data-cy="excel-upload-table-header-mcdr-number">MCDR No</span>
          </th>
          <th class="list-header-element">
            <span data-cy="excel-upload-table-header-igef-number">IGEF No</span>
          </th>
          <th class="list-header-element">
            <span data-cy="excel-upload-table-header-colour-code">Colour code</span>
          </th>
          <th class="ignore-column"></th>
        </tr>
      </thead>
      <tbody>
        @for (material of invalidMaterials; track material) {
          <tr class="list-row" data-cy="excel-upload-table-row">
            <td class="list-element">
              <span data-cy="excel-upload-table-element-row-number">{{material.row}}</span>
            </td>
            <td class="list-element">
              <app-tooltip [disable]="$safeNavigationMigration(material.material?.valid)"
                [message]="mapErrorMessages($safeNavigationMigration(material.material?.errors))"
                [tooltipType]="TooltipEnum.ERROR"
                class="display-inline-flex">
                <span data-cy="excel-upload-table-element-material">{{material.material.original}}</span>
              </app-tooltip>
            </td>
            <td class="list-element">
              <app-tooltip [disable]="material.orderQuantity?.valid !== false"
                [message]="mapErrorMessages($safeNavigationMigration(material.orderQuantity?.errors))"
                [tooltipType]="TooltipEnum.ERROR"
                class="display-inline-flex">
                <span data-cy="excel-upload-table-element-quantity">{{material.orderQuantity.original}}</span>
              </app-tooltip>
            </td>
            <td class="list-element">
              <app-tooltip [disable]="$safeNavigationMigration(material.modelType?.valid)"
                [message]="mapErrorMessages($safeNavigationMigration(material.modelType?.errors))"
                [tooltipType]="TooltipEnum.ERROR"
                class="display-inline-flex">
                <span data-cy="excel-upload-table-element-model-type">{{material.modelType.original}}</span>
              </app-tooltip>
            </td>
            <td class="list-element">
              <app-tooltip [disable]="$safeNavigationMigration(material.lotNumber?.valid)"
                [message]="mapErrorMessages($safeNavigationMigration(material.lotNumber?.errors))"
                [tooltipType]="TooltipEnum.ERROR"
                class="display-inline-flex">
                <span data-cy="excel-upload-table-element-lot-number">{{material.lotNumber.original}}</span>
              </app-tooltip>
            </td>
            <td class="list-element">
              <app-tooltip [disable]="$safeNavigationMigration(material.mcdrNumber?.valid)"
                [message]="mapErrorMessages($safeNavigationMigration(material.mcdrNumber?.errors))"
                [tooltipType]="TooltipEnum.ERROR"
                class="display-inline-flex">
                <span data-cy="excel-upload-table-element-mcdr-number">{{material.mcdrNumber.original}}</span>
              </app-tooltip>
            </td>
            <td class="list-element">
              <app-tooltip [disable]="$safeNavigationMigration(material.igefNumber?.valid)"
                [message]="mapErrorMessages($safeNavigationMigration(material.igefNumber?.errors))"
                [tooltipType]="TooltipEnum.ERROR"
                class="display-inline-flex">
                <span data-cy="excel-upload-table-element-igef-number">{{material.igefNumber.original}}</span>
              </app-tooltip>
            </td>
            <td class="list-element">
              <app-tooltip [disable]="$safeNavigationMigration(material.colourCode?.valid)"
                [message]="mapErrorMessages($safeNavigationMigration(material.colourCode?.errors))"
                [tooltipType]="TooltipEnum.ERROR"
                class="display-inline-flex">
                <span data-cy="excel-upload-table-element-colour-code">{{material.colourCode.original}}</span>
              </app-tooltip>
            </td>
            <td class="ignore-column"></td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <div class="modal-footer">
    <button (click)="activeModal.close()"
      class="btn-secondary"
      data-cy="excel-upload-modal-button-cancel"
      type="button">
      <span class="text">Cancel</span>
    </button>
    <button (click)="continue()"
      class="btn-primary"
      data-cy="excel-upload-modal-button-continue"
      type="button">
      <span class="text">Continue</span>
    </button>
  </div>
</div>
